import React from 'react';
import { Typography, CircularProgress } from '@material-ui/core';

import useStyles from './styles';
import { useSuspensionStatus } from '../../../../utils/effects/useSuspensionStatus';

const successStatusKey = 'Completed';

const CellName = ({ id, status, name, companyId, filePqf, handleLoad }) => {
  const classes = useStyles({ status });
  const isSuspended = useSuspensionStatus();

  if (filePqf.includes(id)) {
    return <CircularProgress size={24} />;
  }

  return (
    <>
      {status === successStatusKey ? (
        <Typography
          display="inline"
          onClick={isSuspended ? undefined : () => handleLoad(companyId, id)}
          className={isSuspended ? undefined : classes.load}
          variant="body1"
          style={isSuspended ? { color: '#999', cursor: 'not-allowed' } : {}}
        >
          {name}
        </Typography>
      ) : (
        <Typography display="inline" variant="body1">
          {name}
        </Typography>
      )}
    </>
  );
};

export default CellName;
